
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import fullImageModal from '@/components/fullImageModal.vue';
import store from '@/store';

@Options({})
export default class toDoContainer extends Vue {

    @Prop() toDos: OM.ToDo[];
    @Prop({
        type: Boolean,
        default: true
    }) modify: boolean;

    tempFile: File = null;
    filesToUpload: File[] = [];

    commentText: string = "";

    addComment(){
        if(!this.canSaveComment)
            return;

        let addBody: VM.AddCommentEvent = {
            fileList: this.filesToUpload,
            text: this.commentText,
        }
        this.$emit('add', addBody);
        this.commentText = "";
        this.filesToUpload = [];
    }

    deleteComment(item: OM.Comment){
        if(!confirm("Confermi?"))
            return;

        this.$emit('deleteComment', item);
    }

    onDrop(ev){
        this.tempFile = ev.dataTransfer.files[0];
        this.addFile();
    }

    addFile(){
        this.filesToUpload.push(this.tempFile);
        this.tempFile = null;
    }

    removeFile(item: File){
        let index = this.filesToUpload.findIndex(x => x == item);
        this.filesToUpload.splice(index, 1);
    }
    
    get canSaveComment(){
        return this.commentText || this.filesToUpload.length > 0;
    }

    openAttachment(ev){
        if(!window.cordova)
            return;

        store.state.openBrowser(ev);

        // ev.preventDefault();
        // this.$opModal.show(fullImageModal, {
        //     imgPreview: ev.target.href
        // })
    }

}

